export enum Region{
  Asia_Singapore = "Asia/Singapore",
  Asia_Seoul = "Asia/Seoul",
  Australia_Darwin = "Australia/Darwin",
  UTC = "America/Danmarkshavn"
}
